import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import {
  ApiError,
  ApiServiceError,
  GetListRequestParams,
  GetListResponse
} from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { UnverifiedReseller } from "../../resellers.types";
import { requestGetUnverifiedResellers } from "./getUnverifiedResellers.request";

const useGetUnverifiedResellers = (
  requestParams: GetListRequestParams,
  options?: QueryOptions<
    GetListResponse<UnverifiedReseller>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["reseller", "admin", "unverified", "all", requestParams],
    queryFn: async () => await requestGetUnverifiedResellers(requestParams),
    onError: toastServerError,
    ...options
  });

  return { unverifiedResellers: data?.data, meta: data?.meta, ...rest };
};

export default useGetUnverifiedResellers;
